export const TRANSACTIONS_URL = {
	SERVICE_CASES_HEADER: `/service-cases/header`,
	A_PRINCIPLE: "a-principle",
	B_CARE_AREA: "b-care-area",
	C_OPC: "c-opc",
	D_REGION: "d-regoin",
	FUNCTIONAL_OPC: "functional-opc",
	SERVICE_CASES_DETAIL: `/service-cases/detail/`,
	CASE_LOG: "service-cases/log",
	AGREEMENT_DETAIL: "service-agreements/detail",
	SERVICE_ORDER_LINE: "service-orders/line",
	WORK_ORDER_DETAIL: "work-orders/detail",
	WORK_ORDER_HEADER: "work-orders/header",
	CHECK_INVOICE: "credit-holds/check-invoice-account",
	SERVICE_CASE_LISTING: "service-cases-listing",
	EMPLOYEES: "employees",
	SERVICE_OBJECT_LISTING: "service-objects-listing",
	CURRENCY: "currency",
	EQUIPMENT: "equipments",
	WORK_ORDER_LISTING: " work-orders-listing",
};
